import cn from "classnames";
import React from "react";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  active?: boolean;
  count?: number;
}

const ChartDot = React.forwardRef<HTMLDivElement, Props>(
  ({ active, count = 0, className, ...rest }, ref) => (
    <div
      ref={ref}
      className={cn(
        "bg-card inline-flex h-4 items-center rounded-full shadow-md",
        className,
      )}
      {...rest}
    >
      <div className="flex size-4 items-center justify-center">
        <div
          className={cn(
            "size-2 rounded-full",
            active ? "bg-chart-1" : "bg-border",
          )}
        />
      </div>
      {count > 0 && (
        <span className="text-muted-foreground pr-1.5 text-[0.65rem] leading-none font-medium">
          +{count}
        </span>
      )}
    </div>
  ),
);

ChartDot.displayName = "ChartDot";

export default ChartDot;
